import type {ReactNode} from 'react';
import Header from 'components/Header';
import PhoneNumbers from 'constants/PhoneNumbers';
import Footer from 'components/Footer';
import Helmet from 'components/Helmet';
import LoadingSpinner from 'components/LoadingSpinner';

interface LayoutProps {
  children: ReactNode;
  title: string;
  loading?: boolean;
  orderNumber?: string;
}

const Layout = ({children, title, loading, orderNumber}: LayoutProps) => {
  return (
    <>
      <Helmet title={title}>
        <meta name="apple-itunes-app" content="app-id=1439463312" />
        <meta name="google-play-app" content="app-id=com.ezcater.ezmanage" />
        <link rel="apple-touch-icon" href="/static/images/brand/icon-48x48.png" />
        <link rel="android-touch-icon" href="/static/images/brand/icon-48x48.png" />
      </Helmet>
      {loading && <LoadingSpinner />}
      {!loading && (
        <>
          <Header orderNumber={orderNumber}>{children}</Header>
          <Footer phone={PhoneNumbers.EZDISPATCH_DIRECT} />
        </>
      )}
    </>
  );
};

export default Layout;
